var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.297,
    height: 36.78
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16054",
    transform: "translate(-686 -218)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37909",
    d: "M707.148 218l21.152 36.78H686z",
    fill: "#ffe836"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 175",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M707.149 242.224v-12"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 383",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "rotate(180 354.325 123.824)"
  }))));
}

export default SvgWarning;